import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "emotion";

import Container from "./shared/Container";
import styleConfig from "styles/styleConfig";

const { margin, padding, colors, fontSize, transition, screens } = styleConfig;

const footerStyle = css`
  padding: ${padding[6]} ${padding[4]};
  color: ${colors.black};
  background-color: ${colors.gray[100]};
  border-top: 1px solid ${colors.gray[200]};
  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media (max-width: ${screens.MOBILE_WIDTH}px) {
      flex-direction: column;
      text-align: center;
    }
  }
  .zone {
    display: flex;
    margin-bottom: ${margin[4]};
    .image {
      position: relative;
      width: 45px;
      margin-right: ${margin[8]};
      img {
      }
    }
    h3 {
      margin: ${margin[2]} 0;
      font-size: ${fontSize.sm};
      text-transform: uppercase;
    }
    p {
      font-size: ${fontSize.xs};
    }
    a {
      color: ${colors.primary[300]};
      transition: ${transition.default};
      &:hover {
        color: ${colors.primary[600]};
      }
    }
  }
  @media (max-width: ${screens.MOBILE_WIDTH}px) {
    .zone {
      justify-content: center;
      margin: ${margin[2]} 0;
      &:first-child {
        margin: 0 0 ${margin[2]};
      }
      /* &:last-child {
        margin: ${margin[2]} 0 0;
      } */
    }
  }
  .payment-methods {
    display: flex;
    img {
      margin: auto;
    }
  }
`;

interface Props {}

const Footer: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className={footerStyle}>
      <Container className="container">
        <div className="content">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="zone">
              <div className="image">
                <img src="./assets/contact.svg" alt="contact" />
              </div>
              <div>
                <h3>{t(`footer.questions`)}</h3>
                <p>
                  <a href="tel:(09) 357 69 11">(09) 357 69 11</a>
                </p>
              </div>
            </div>
            <div className="zone">
              <div className="image">
                <img src="./assets/mail.svg" alt="mail" />
              </div>
              <div>
                <p>
                  <a href="mailto:erbasupermarkt@hotmail.com">erbasupermarkt@hotmail.com</a>
                </p>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="zone">
              <div className="image">
                <img src="./assets/location.svg" alt="location" />
              </div>
              <div>
                <h3>{t(`footer.location`)}</h3>
                <p>
                  Frans van Ryhovelaan 148 <br />
                  9000, Gent/België
                </p>
              </div>
            </div>
            <div className="zone">
              <div>
                <div className="payment-methods">
                  <img src="./assets/cash.svg" alt="contant" />
                  <img src="./assets/visa.png" alt="visa" height={40} />
                  <img src="./assets/bancontact.png" alt="bancontact" width={70} />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <img src="./assets/mastercard.png" alt="mastercard" width={40} />
                    <img src="./assets/maestro.png" alt="maestro" width={40} />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <img src="./assets/edenred.png" alt="edenred" width={40} />
                    <img src="./assets/sodexo.png" alt="sodexo" width={40} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="zone">
            <div className="image">
              <img src="./assets/share.svg" alt="share" />
            </div>
            <div>
              <h3>{t(`footer.social_media`)}</h3>
              <a
                href="https://www.facebook.com/erbasupermarkt/"
                target="_blank"
                rel="noopener noreferrer"
                className={css`
                  margin: 0 0.5rem;
                `}
              >
                <img src="./assets/facebook.svg" alt="facebook" />
              </a>
              <a
                href="https://instagram.com/erbasupermarkt"
                target="_blank"
                rel="noopener noreferrer"
                className={css`
                  margin: 0 0.5rem;
                `}
              >
                <img src="./assets/instagram.svg" alt="instagram" />
              </a>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
